import { useCallback, useMemo, useState } from "react";
export const useNotificationUtils = () => {
  const isAvailable = typeof globalThis !== "undefined" && globalThis.Notification !== undefined;
  const {
    0: permission,
    1: setPermission
  } = useState(isAvailable ? globalThis.Notification.permission : undefined);
  const isGranted = useMemo(() => permission === "granted", [permission]);
  const isDenied = useMemo(() => permission === "denied", [permission]);
  const isPrompt = useMemo(() => permission === "default", [permission]);
  const requestPermission = useCallback(async () => {
    if (!isAvailable) return;
    const result = await Notification.requestPermission();
    setPermission(result);
    return result;
  }, [isAvailable]);
  return {
    isAvailable,
    isDenied,
    isGranted,
    isPrompt,
    permission,
    requestPermission
  };
};